import { Container, Row } from "reactstrap";
import ClipboardOnParagraph from "./ClipboardOnParagraph";
import ClipboardOnTextArea from "./ClipboardOnTextArea";
import ClipboardOnTextInput from "./ClipboardOnTextInput";
import CopyPortionFromParagraph from "./CopyPortionFromParagraph";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { ClipBoardTitle, FormWidgetsTitle } from "../../../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";

const ClipboardContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ClipBoardTitle} parent={FormWidgetsTitle} />
      <Container fluid>
        <Row>
          <ClipboardOnTextInput />
          <ClipboardOnTextArea />
          <ClipboardOnParagraph />
          <CopyPortionFromParagraph />
        </Row>
      </Container>
    </Fragment>
  );
};
export default ClipboardContainer;
